'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _class);

  this.els = {
    el: el,
    button: (0, _functional.getElement)('.ck-Banner_Button', { context: el })
  };

  function applyCSSVariable(offset) {
    document.querySelector(':root').style.setProperty('--cookie-banner-height', offset + 'px');
  }

  if (el.classList.contains('ck-Banner-active')) {
    applyCSSVariable(el.offsetHeight);
  }

  var myObserver = new ResizeObserver(function (entries) {
    if (el.classList.contains('ck-Banner-active')) {
      applyCSSVariable(el.offsetHeight);
    } else {
      applyCSSVariable(0);
    }
  });

  myObserver.observe(el);

  this.els.button.addEventListener('click', function (e) {
    _jsCookie2.default.set('sophie-allport-cookie-information', 'true', {
      expires: 3650
    });
    _this.els.el.classList.remove('ck-Banner-active');
    applyCSSVariable(0);
  });
};

exports.default = _class;